import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';

const TermsPage = () => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const fetchDocs = async () => {
      setLoading(true);
      setError('');

      try {
        const base = process.env.REACT_APP_API_URL;
        const types = ['common', 'buyer', 'seller'];

        const responses = await Promise.all(
          types.map((type) => axios.get(`${base}/terms/current?type=${type}`))
        );

        if (!cancelled) {
          setDocs(responses.map((res) => res.data));
        }
      } catch (e) {
        if (!cancelled) {
          setError('利用規約の取得に失敗しました。時間をおいて再度お試しください。');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchDocs();
    return () => {
      cancelled = true;
    };
  }, []);

  const formatDate = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('ja-JP');
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px 64px', lineHeight: 1.8 }}>
      <h1 style={{ marginTop: 0 }}>利用規約</h1>
      {loading && <p>読み込み中...</p>}
      {!loading && error && <p style={{ color: '#dc2626' }}>{error}</p>}
      {!loading && !error && docs.map((doc) => (
        <section key={doc.id} style={{ marginBottom: 28 }}>
          <h1 style={{ marginBottom: 8 }}>{doc.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(doc.content || '') }} />
        </section>
      ))}
    </div>
  );
};

export default TermsPage;
